import { requestService, TAsyncActionOptions } from '@trader/services';
import { instrumentRoutes } from './routes';
import {
  IGetInstrumentsBody,
  IInstrumentDetailsBE,
  IInstrumentItems,
  IOrderDetailsBE,
} from './models/instrument';

export class Instrument {
  routes = instrumentRoutes;

  async getInstruments(
    params: IGetInstrumentsBody,
    options: TAsyncActionOptions
  ): Promise<IInstrumentItems> {
    const resp = await requestService.get<IInstrumentItems>(
      this.routes.getInstruments(params),
      {
        ...options.cancelToken,
      }
    );

    return resp?.data;
  }

  async getRelatedInstruments(
    symbol: string,
    options: TAsyncActionOptions
  ): Promise<IInstrumentItems> {
    const resp = await requestService.get<IInstrumentItems>(
      this.routes.getRelatedInstuments(symbol),
      {
        ...options.cancelToken,
      }
    );

    return resp?.data;
  }

  async getInstrumentDetails(
    symbol: string,
    options: TAsyncActionOptions
  ): Promise<IInstrumentDetailsBE> {
    const resp = await requestService.get<IInstrumentDetailsBE>(
      this.routes.getInstrumentDetails(symbol),
      {
        ...options.cancelToken,
      }
    );

    return resp?.data;
  }

  async getOrderDetails(
    symbol: string,
    options: TAsyncActionOptions
  ): Promise<IOrderDetailsBE> {
    const resp = await requestService.get<IOrderDetailsBE>(
      this.routes.getOrderDetails(symbol),
      {
        ...options.cancelToken,
      }
    );

    return resp?.data;
  }

  async searchInstruments(
    symbol: string,
    options: TAsyncActionOptions
  ): Promise<IInstrumentItems> {
    const resp = await requestService.get<IInstrumentItems>(
      this.routes.searchInstuments(symbol),
      {
        ...options.cancelToken,
      }
    );

    return resp?.data;
  }

  async addInstrumentToFavorite(
    instrumentId: number,
    options: TAsyncActionOptions
  ): Promise<void> {
    const resp = await requestService.post<void>(
      this.routes.favorite(instrumentId),
      {},
      {
        ...options.cancelToken,
      }
    );

    return resp?.data;
  }

  async deleteInstrumentFromFavorite(
    instrumentId: number,
    options: TAsyncActionOptions
  ): Promise<void> {
    const resp = await requestService.delete<void>(
      this.routes.favorite(instrumentId),
      {},
      {
        ...options.cancelToken,
      }
    );

    return resp?.data;
  }
}
